import { Routes } from '@angular/router';

import { AuthGuard } from '../auth.guard';
import { SupportHomeComponent } from './support-home/support-home.component';
import { RootComponent } from '../root/root.component';
import { FaqListComponent } from './faq-list/faq-list.component';
import { FaqEditComponent } from './faq-edit/faq-edit.component';

export const routing: Routes = [
  {
    path: 'support',
    component: RootComponent, canActivate: [AuthGuard],

    children: [
      { path: '', component: FaqListComponent },
      { path: 'list', component: FaqListComponent },
      { path: 'add', component: FaqEditComponent },
      { path: 'edit/:faqId', component: FaqEditComponent },

      { path: 'Faqs', component: SupportHomeComponent },
    ]
  }
];
